import { startCase } from "lodash";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { apiPut } from "../../Utils/apiFetch";
import {apiPath} from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { levelMap } from "../../Utils/Constant";

export default function UpdateStatusUser({
  changeStatus,
  setChangeStatusToggle,
  userData,
  getActiveClass,
  setActiveClass,
  getUsers,
  currentStatus,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [isLoader, setLoader] = useState(false);

  useEffect(() => {
    if (!changeStatus) {
      reset();
      setLoader(false);
    }
  }, [changeStatus]);

  if (!changeStatus) return null;

  const handleUserStatus = (status) => {
    setActiveClass(status);
  };

  const onSubmit = async (request) => {
    if (!getActiveClass) {
      toast.error("Please select status");
      return;
    }

    setLoader(true);
    try {
      const { status, data } = await apiPut(
        `${apiPath.profileChangeStatus}/${userData._id}`,
        { status: getActiveClass, password: request.password },
      );
      if (status === 200 && data.success) {
        toast.success(data.message);
        setChangeStatusToggle();
        getUsers();
        reset();
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const closeModal = () => {
    reset();
    setChangeStatusToggle();
  };

  const showActive = currentStatus === "downline" || currentStatus !== "active";
  const showSuspend = currentStatus !== "suspend";
  const showLocked = currentStatus !== "locked";

  return (
    <div
      id="createModal"
      className="pop_bg"
      style={{ height: "100%", width: "100%", display: "block" }}
      onClick={closeModal}
    >
      <div className="pop_box pop_refer" onClick={(e) => e.stopPropagation()}>
        <a
          href="#"
          className="close_pop"
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        >
          close_pop
        </a>

        <h3
          className="modal-header"
          style={{ padding: "9px 15px", borderBottom: "1px solid #e5e5e5" }}
        >
          Change Status
        </h3>

        <div style={{ background: "white" }} className="modal-content">
          <div className="status_id">
            <p id="changeAccount">
              <span className={`Bdlevel ${levelMap[userData?.userType]}`} />
              {userData?.username}
            </p>
            <p
              id="originalStatus"
              className={`status-${userData?.status || ""}`}
            >
              <img src="/assets/images/transparent.gif" alt="" />
              {startCase(userData?.status)}
            </p>
          </div>

          <div className="white-wrap">
            <ul id="statusBtn" className="status_but">
              {showActive && (
                <li>
                  <a
                    href="#"
                    id="activeBtn"
                    className={`but_active betgameactive ${
                      getActiveClass === "active" ? "open" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleUserStatus("active");
                    }}
                  >
                    <img src="/assets/images/transparent.gif" alt="" /> Active
                  </a>
                </li>
              )}

              {showSuspend && (
                <li>
                  <a
                    href="#"
                    id="suspendBtn"
                    className={`but_suspend betgameLocked ${
                      getActiveClass === "suspend" ? "open" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleUserStatus("suspend");
                    }}
                  >
                    <img src="/assets/images/transparent.gif" alt="" /> Suspend
                  </a>
                </li>
              )}

              {showLocked && (
                <li>
                  <a
                    href="#"
                    id="lockedBtn"
                    className={`but_locked betgameLocked ${
                      getActiveClass === "locked" ? "open" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleUserStatus("locked");
                    }}
                  >
                    <img src="/assets/images/transparent.gif" alt="" /> Locked
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div className="modal-footer">
            <form
              noValidate
              style={{ width: "100%" }}
              className="btn_box inline-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="form_list">
                <label>Password:</label>
                <input
                  id="changeStatusPassword"
                  type="password"
                  placeholder="Enter"
                  style={{ marginBottom: "0" }}
                  className={errors.password ? "is-invalid" : ""}
                  {...register("password", {
                    required: "Please enter password",
                  })}
                />
                {errors.password && (
                  <span className="error-text">{errors.password.message}</span>
                )}
              </div>

              <div className="btn_box">
                <button
                  style={{ width: "100%", margin: "0" }}
                  id="changeStatusBtn"
                  type="submit"
                  className="btn-send"
                  disabled={isLoader}
                >
                  {isLoader ? "Loading..." : "Change"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
